import React from 'react';
import {TouchableOpacity, View} from 'react-native';
import {useNavigation} from '@react-navigation/native';

import {useTheme} from '../../../../../shared/theme';
import {NewsResponsePayload} from '../../../../../shared/models/api';
import {Image} from '../../../../../shared/components/image';
import {Text} from '../../../../../shared/components/text';
import {Screens} from '../../../../../shared/routing';
import {stripHTML} from '../../../../../shared/pipes';
import getStyle from './style';

import './style.scss';

export const NewsItem = ({newsItem}: {newsItem: NewsResponsePayload}) => {
  const navigation = useNavigation();
  const theme = useTheme();

  const dataCard = {
    dataSet: {
      class: 'news-card',
    },
  };

  const styles = getStyle(theme);

  return (
    <TouchableOpacity
      testID={`news-card-item-${newsItem.id}`}
      activeOpacity={1}
      onPress={() => navigation.navigate(Screens.NewsArticle, {id: newsItem.id})}
      key={newsItem.id}>
      <View {...dataCard} style={styles.newsCard}>
        <Image
          source={newsItem.image as any}
          resizeMode='cover'
          style={styles.newsImage}
          testID={`news-card-item-${newsItem.id}-image`}
        />
        <View style={styles.newsText}>
          <Text type='body' color={theme.color.labelText} testID={`news-card-item-${newsItem.id}-createdAt`}>
            {newsItem.createdAt}
          </Text>
          <Text type='h5' testID={`news-card-item-${newsItem.id}-title`}>
            {newsItem.name}
          </Text>
          <Text type='body' numberOfLines={3} ellipsizeMode='tail' testID={`news-card-item-${newsItem.id}-description`}>
            {stripHTML(newsItem.description)}
          </Text>
          {/* <HiddenContentBlock numberOfLines={3} lineHeight={isDesktop ? 30 : 26}>
          <Html content={newsItem.description} />
        </HiddenContentBlock> */}
        </View>
      </View>
    </TouchableOpacity>
  );
};
